module.exports = __webpack_public_path__ + "img/vortex.d50caafa.png";